import { InlineHtml } from './InlineHtml';

export { InlineHtml, type InlineHtmlProps } from './InlineHtml';
export { ArticleLoginWall, type ArticleLoginWallProps } from './ArticleLoginWall';

export default InlineHtml;
